import { FC } from "react";
import { TPageUrl } from "../../../routing/accessMap";
import { Link as RouterLink } from "react-router-dom";
import Link from "@mui/material/Link";

const LinkFormSignIn: FC<{ url?: TPageUrl }> = ({ url = '/oauth/signIn'}) => (  
  <Link to={url} component={RouterLink} variant='body2'>
    Sign in
  </Link>  
);

export default LinkFormSignIn;
